module.exports = __webpack_public_path__ + "img/e33a6714235ac26e85a3ffc3c1c7d448.svg";